module.exports = __webpack_public_path__ + "img/banner4  英文 手机.208326de.png";